import vehiclesReducer from './vehicles';
import searchResultsPageAliasReducer from './searchResultsPageAlias';
import moreRequestDataReducer from './moreRequestData';

export default {
	vehicles: vehiclesReducer,
	searchResultsPageAlias: searchResultsPageAliasReducer,
	moreRequestData: moreRequestDataReducer
};
